<template>
  <div class="maxbox">
    <!-- 顶部导航栏 -->
    <header class="asset-header">
      <button @click="goback" class="back-button">
        <img src="@/assets/images/left-arrow.png" alt="返回" class="back-icon">
      </button>
      <h1 class="page-title">我的CYC资产</h1>
      <div class="empty-space"></div> <!-- 占位保持标题居中 -->
    </header>
    

    <!-- 主要内容区域 -->
    <main class="asset-main">
      <!-- 会员资产卡片 -->
      <section class="asset-card">
        <div class="card-header">
          <h2 class="card-title">CYC币账户</h2>
        </div>
        
        <div class="card-body">
          <!-- 激活按钮 -->
          <button 
            v-if="memberStatus === 'V1' || memberStatus === 'V2' || memberStatus === 'V3'"
            @click="activateMembership" 
            class="btn activate-btn"
          >
            激活CYC币账户
          </button>
          
          <!-- 资产信息展示 -->
          <div class="asset-info-list">
            <div class="info-item">
              <span class="info-label">领取CYC币状态：</span>
              <span class="info-value">{{ membershipStatus }}</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">今日可领取：</span>
              <span class="info-value highlight">{{ claimableTokensPerAuthorization }} 枚CYC币</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">已挖取CYC币次数：</span>
              <span class="info-value">{{ claimCount }}</span>
            </div>
            
            <div class="info-item">
              <span class="info-label">可领取CYC余额：</span>
              <span class="info-value balance">{{ claimableBalance }} CYC</span>
            </div>
          </div>
          
          <!-- 领取按钮 -->
          <button 
            v-if="memberStatus === 'V1' || memberStatus === 'V2' || memberStatus === 'V3'"
            @click="claimTokens" 
            class="btn claim-btn"
          >
            领取代币
          </button>
        </div>
      </section>

      <!-- 分红历史记录 -->
      <section class="history-card">
        <div class="card-header">
          <h2 class="card-title">CYC幣明細</h2>
        </div>
        
        <div class="history-list">
          <div v-if="dividendHistory.length === 0" class="empty-state">
            暂无分红记录
          </div>
          <ul v-else class="history-items">
            <li v-for="(record, index) in dividendHistory" :key="index" class="history-item">
              <span class="history-date">{{ formatDateByIndex(index) }}</span>
              <span class="history-dividend">分红: {{ record.claimableTokens }} 枚</span>
            </li>
          </ul>
        </div>
      </section>
    </main>
    
  </div>
</template>

<script>
import { ethers } from 'ethers';
import { contractAddresss, contractABII, usdtTokenAddress, usdtAbi } from '@/js/contractsss.js';
import { contractAddress, contractABI } from '@/js/contract.js';

export default {
  name: 'income',
  data() {
    return {
      membershipStatus: '加载中...',
      claimableBalance: '加载中...',
      claimCount: '加载中...',
      memberStatus: '加载中...',
      usdtBalance: '加载中...',
      claimableTokensPerAuthorization: '加载中...',
      dividendHistory: []
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    async connectWallet() {
      if (!window.ethereum) {
        console.error("未检测到Ethereum提供商。请安装MetaMask。");
        return null;
      }
      try {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        return new ethers.providers.Web3Provider(window.ethereum);
      } catch (error) {
        console.error("用户拒绝了账户访问请求", error);
        return null;
      }
    },
    async activateMembership() {
      const provider = await this.connectWallet();
      if (!provider) return;

      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddresss, contractABII, signer);

      try {
        const activateTx = await contract.applyForMembership();
        await activateTx.wait();

        alert("会员激活成功！");
        await this.getMembershipStatus();
        await this.getClaimableBalance();
      } catch (error) {
        console.error("会员激活失败", error);
        alert("会员激活失败，错误详情见控制台。");
      }
    },
    async getMembershipStatus() {
      const provider = await this.connectWallet();
      if (!provider) return;

      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddresss, contractABII, signer);

      try {
        const address = await signer.getAddress();
        const status = await contract.checkMyMembershipStatus({ from: address });
        this.membershipStatus = status;
      } catch (error) {
        console.error("查询会员状态失败", error);
        alert("查询会员状态失败，错误详情见控制台。");
      }
    },
    async getClaimableBalance() {
      const provider = await this.connectWallet();
      if (!provider) return;

      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddresss, contractABII, signer);

      try {
        const address = await signer.getAddress();
        const balance = await contract.checkClaimableBalance({ from: address });
        console.log("Raw claimable balance:", balance);
        this.claimableBalance = parseFloat(ethers.utils.formatUnits(balance, 6)).toFixed(3);
      } catch (error) {
        console.error("查询可领取代币余额失败", error);
        alert("查询可领取代币余额失败，错误详情见控制台。");
      }
    },
    async claimTokens() {
      const provider = await this.connectWallet();
      if (!provider) return;

      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddresss, contractABII, signer);

      try {
        const claimTx = await contract.claimTokens();
        await claimTx.wait();

        alert("代币提取成功！");
        await this.getClaimableBalance();
        await this.getUsdtBalance();
        await this.getClaimCount();
      } catch (error) {
        console.error("代币提取失败", error);
        alert("代币提取失败，错误详情见控制台。");
      }
    },
    async getUsdtBalance() {
      const provider = await this.connectWallet();
      if (!provider) return;

      const signer = provider.getSigner();
      const usdtContract = new ethers.Contract(usdtTokenAddress, usdtAbi, signer);

      try {
        const address = await signer.getAddress();
        const balance = await usdtContract.balanceOf(address);
        console.log("Raw USDT balance:", balance);
        this.usdtBalance = parseFloat(ethers.utils.formatUnits(balance, 6)).toFixed(6);
      } catch (error) {
        console.error("查询USDT余额失败", error);
        alert("查询USDT余额失败，错误详情见控制台。");
      }
    },
    async checkClaimCount() {
      const provider = await this.connectWallet();
      if (!provider) return;

      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddresss, contractABII, signer);

      try {
        const address = await signer.getAddress();
        const count = await contract.checkClaimCount({ from: address });
        console.log("已提取代币次数:", count);
        this.claimCount = count.toNumber();
      } catch (error) {
        console.error("查询已提取代币次数失败", error);
        alert("查询已提取代币次数失败，错误详情见控制台。");
      }
    },
    async getClaimCount() {
      await this.checkClaimCount();
    },
    async getMemberDetail() {
      const provider = await this.connectWallet();
      if (!provider) return;

      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddress, contractABI, signer);

      try {
        const address = await signer.getAddress();
        const status = await contract.getMemberStatus(address);
        console.log("会员状态:", status);
        this.memberStatus = status;
      } catch (error) {
        console.error("查询会员状态失败", error);
        alert("查询会员状态失败，错误详情见控制台。");
      }
    },
    async getClaimableTokensPerAuthorization() {
      const provider = await this.connectWallet();
      if (!provider) return;

      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddresss, contractABII, signer);

      try {
        const tokensPerAuthorization = await contract.getClaimableTokensPerAuthorization();
        console.log("每天可领取代币数量:", tokensPerAuthorization);
        this.claimableTokensPerAuthorization = parseFloat(ethers.utils.formatUnits(tokensPerAuthorization, 6)).toFixed(3);
      } catch (error) {
        console.error("查询每天可领取代币数量失败", error);
        alert("查询每天可领取代币数量失败，错误详情见控制台。");
      }
    },
    async getDividendHistory() {
      const provider = await this.connectWallet();
      if (!provider) return;

      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddresss, contractABII, signer);

      try {
        const history = await contract.getValidDividendHistory();
        console.log("历史分红比例记录:", history);

        this.dividendHistory = history.map((record, index) => {
          return {
            claimableTokens: parseFloat(ethers.utils.formatUnits(record.claimableTokens, 6)).toFixed(3),
            index: index
          };
        }).reverse();
      } catch (error) {
        console.error("查询历史分红比例记录失败", error);
        alert("查询历史分红比例记录失败，错误详情见控制台。");
      }
    },
    formatDateByIndex(index) {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - index);
      return currentDate.toLocaleDateString();
    }
  },
  mounted() {
    this.getMemberDetail();
    this.getMembershipStatus();
    this.getClaimableBalance();
    this.getUsdtBalance();
    this.getClaimCount();
    this.getClaimableTokensPerAuthorization();
    this.getDividendHistory();
  }
};
</script>

<style scoped>
/* 全局样式重置和基础设置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.maxbox {
  min-height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏样式 */
.asset-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  /* background-color: #ffffff; */
  background-color: rgb(153, 153, 153, 0.2);
  color: #555;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 100;
}

.back-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.back-button:hover {
  background-color: #f0f2f5;
}

.back-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
}

.empty-space {
  width: 40px; /* 与返回按钮宽度保持一致，使标题居中 */
}

/* 主要内容区域 */
.asset-main {
  
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: #4da6ff5b;
  /* background-color: rgba(255, 255, 255, 0.5); */
}

/* 卡片通用样式 */
.asset-card, .history-card {

  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: 2px solid white;
}

.asset-card:hover, .history-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  
}

.card-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f2f5;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
}

.card-body {
  padding: 20px;
}

/* 按钮样式 */
.btn {
  display: block;
  width: 100%;
  padding: 12px 0;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 20px;
}

.activate-btn {
  background-color: #4080ff;
  color: #ffffff;
}

.activate-btn:hover {
  background-color: #3370e7;
}

.claim-btn {
  background-color: #00b42a;
  color: #ffffff;
}

.claim-btn:hover {
  background-color: #00a627;
}

/* 资产信息列表 */
.asset-info-list {
  margin-bottom: 20px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f5f7fa;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 14px;
  color: #4e5969;
}

.info-value {
  font-size: 14px;
  color: #1d2129;
  font-weight: 500;
}

.info-value.highlight {
  color: #4080ff;
}

.info-value.balance {
  color: #f53f3f;
  font-size: 16px;
  font-weight: 600;
}

/* 历史记录样式 */
.history-list {
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
}

.empty-state {
  text-align: center;
  padding: 40px 0;
  color: #86909c;
  font-size: 14px;
}

.history-items {
  list-style: none;
}

.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f5f7fa;
}

.history-item:last-child {
  border-bottom: none;
}

.history-date {
  font-size: 14px;
  color: #4e5969;
}

.history-dividend {
  font-size: 14px;
  color: #1d2129;
 
  font-weight: 500;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .asset-main {
    padding: 16px 12px;
  }
  
  .card-body, .history-list {
    padding: 16px;
  }
  
  .info-item {
    padding: 10px 0;
  }
  
  .history-item {
    padding: 10px 0;
  }
}

/* 滚动条样式优化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #c0c4cc;
}
</style>
